import PurchaseOrderList from './PurchaseOrderList';
export default PurchaseOrderList;
